module.exports = __webpack_public_path__ + "img/img30.9405f4d9.jpg";